import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'
import { getAnalytics, isSupported as analyticsIsSupported } from 'firebase/analytics'

const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyAjbQPYjAEfmj822AMUhbB9NpybQytJ8gA',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'ascendant-road-holdings-llc.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'ascendant-road-holdings-llc',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'ascendant-road-holdings-llc.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '1039685741562',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:1039685741562:web:c9194d8d438fb71499d243',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? 'G-KVWGX1RKZN',
}

const DB_ID = import.meta.env.VITE_FIRESTORE_DATABASE_ID ?? 'acquisition-prep'
const FN_REGION = import.meta.env.VITE_FUNCTIONS_REGION ?? 'us-central1'

export const ALLOWED_EMAILS: readonly string[] = (
  import.meta.env.VITE_ALLOWED_EMAILS ??
  'info@reminiscentroadmedia.com'
).split(',').map((s) => s.trim().toLowerCase()).filter(Boolean)

export const app: FirebaseApp = initializeApp(cfg)
export const auth = getAuth(app)

try {
  initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  }, DB_ID)
} catch {
  // already initialized in HMR — fall through to getFirestore
}
export const db = getFirestore(app, DB_ID)
export const functions = getFunctions(app, FN_REGION)
export const storage = getStorage(app)

export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({ prompt: 'select_account' })

if (typeof window !== 'undefined' && import.meta.env.PROD) {
  analyticsIsSupported().then((ok) => {
    if (ok) getAnalytics(app)
  }).catch(() => undefined)
}
